import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Popup from "../../User/popup";
import { TextArea } from "../../components/_input/_textArea";
import SimpleButton from "../../components/_input/SimpleButton";
import { useParams } from "react-router";
import PopupHeader from "../../User/components/popupHeader";
import config from '../../configuration/config';
import { useHistory, useLocation } from "react-router";
import { GetMessages, formValidate } from '../../utils/validation';
import Joi from "joi";
import { Swiper, SwiperSlide } from "swiper/react";
import Skeleton from 'react-loading-skeleton'
import { EvaluationType } from "./components/EvaluationType";
import { toast } from "react-toastify";
import { Price } from "../../components/__simple/_price";
import { Helmet } from "react-helmet";
import CustomItemServices from "../../components/CustomItemServices";
import { CheckInput } from "../../components/_input/_checkInput";
import { filter } from "lodash";
export function ProtectionAndShading() {

    let { PVIN, PUser, PGroupID, PYear, PServiceID } = useParams();
    const { t: trans, i18n } = useTranslation(["info", "employment", "eparts", "common", "global", "offers", "cartFile"]);
    let lang = (i18n.language || 'ar');
    const location = useLocation();
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    const query = new URLSearchParams(location.search);
    const [paramGUID, setParamGUID] = useState(query.get("Id") && guidRegex.test(query.get("Id")) ? query.get("Id") : null);
    const [paramJobCardGUID, setParamJobCardGUID] = useState(query.get("JobCardID") ?? null);
    const [pSalesorderid, setSalesorderid] = useState(query.get("Salesorderid") ?? null);
    const [sadadInfo, setSadadInfo] = useState(null);
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [showFinalPopupMessage, setShowFinalPopupMessage] = useState("");
    const popRef = useRef(null);
    const [Agreements, setAgreements] = useState([]);
    const [resOrderID, setResOrderID] = useState(null);
    const history = useHistory();
    const [stepNum, setStepNum] = useState(1);
    const [dataFullNum, setDataFullNum] = useState(0);
    const [VINDetails, setVINDetails] = useState(null);
    const [SalesInvoiceTrans, setSalesInvoiceTrans] = useState([]);
    const [infoPrice, setinfoPrice] = useState([{ Price: 0 }]);
    const [isSendeng, setIsSendeng] = useState(false);
    const [orderReservation, setOrderReservation] = useState(null);
    const [allselectServices, setAllSelectServices] = useState([]);
    const [selectService, setSelectService] = useState({});
    const [acticeService, setActiceService] = useState(null);
    const [acticeMenu, setActiceMenu] = useState("Saving Packages");
    const [selsub0, setselsub0] = useState({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
    const [paymentType, setPaymentType] = useState(null);
    const [isToggleSwitch, setIsToggleSwitch] = useState(true);
    const [showAgreements, setshowAgreements] = useState(false);
    const [showTintingAgreements, setshowTintingAgreements] = useState({
        en: "Tinting is allowed on the rear side windows up to (grades 00, 01, or 02).\nTinting the front windows or the windshield is not permitted except with medical approval.",
        ar: "يسمح بالتظليل على النوافذ الخلفية الجانبية حتى (الدرجات 00 أو 01 أو 02).\nلا يُسمح بتظليل النوافذ الأمامية أو الزجاج الأمامي إلا بموافقة طبية."
    });

    const [indexPanel, setIndexPanel] = useState("1000");
    const [brand, setBrand] = useState(null);
    const [type, setType] = useState(null);
    const [group, setGroup] = useState(null);
    const [vModelCode, setVModelCode] = useState([]);
    const [year, setYear] = useState(null);
    const [MessageError, setMessageError] = useState(null);
    const [evaluations, setEvaluations] = useState({
        evaluation_false_0: 0,
        evaluation_false_1: 0.2,
        evaluation_false_2: 0.2,
        evaluation_false_3: 0.2,
        evaluation_true_0: 0.2,
    });
    const evaluationOptions = [{
        titel: "زجاج أمامي",
        titelEn: "Windshield",
        mandatory: false,
        defultValue: 0
    },
    {
        titel: "زجاج خلفي",
        titelEn: "Rear glass",
        mandatory: true,
        defultValue: 0.2
    },
    {
        titel: "زجاج جانبي  أمامي ",
        titelEn: "Front side glass",
        mandatory: true,
        defultValue: 0.2
    },
    {
        titel: "زجاج جانبي  خلفي",
        titelEn: "Rear side glass",
        mandatory: true,
        defultValue: 0.2
    },];
    const [requestForm, setRequestForm] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        date: '',
        time: '',
        messageContent: '',
        myCarID: '',
        SiteID: null,
        ServiceID: ''
    });
    const [filteredSettings, setFilteredSettings] = useState({
        brands: [],
        groups: [],
        models: [],
        productModels: []
    });


    const [settings, setSettings] = useState({
        brands: [],
        groups: [],
        models: [],
        productModels: []
    });

    const [platformTypes, setPlatformTypes] = useState([]);

    useEffect(() => {


        var price = 100;
        if (allselectServices && allselectServices.length > 0) {
            price = allselectServices?.reduce((total, service) => total + service.Price, 0)
        }
        console.info("tabby-promo price:", price);
        // Remove any existing Tabby script
        const existingScript = document.getElementById('tabby-script');
        console.info("existingScript:", existingScript);
        if (existingScript) {
            existingScript.remove();
        }

        // Dynamically load the script
        const script = document.createElement('script');
        script.src = 'https://checkout.tabby.ai/tabby-promo.js';
        script.id = 'tabby-script';
        script.async = true;

        script.onload = () => {
            // Ensure TabbyPromo is available globally
            if (window.TabbyPromo) {
                new window.TabbyPromo({
                    selector: '#TabbyPromo',
                    currency: 'SAR',
                    price: price,
                    lang: lang,
                    source: 'product',
                    publicKey: 'pk_d9c08e9a-62dc-4f32-961b-55fcfc499988',
                    merchantCode: 'HJKSA',
                    // shouldInheritBg:false
                });
            }
        };

        document.body.appendChild(script);

        // Clean up script on component unmount
        // Cleanup
        return () => {
            const oldScript = document.getElementById('tabby-script');
            if (oldScript) {
                oldScript.remove();
            }
        };

    }, [allselectServices, lang]);
    useEffect(() => {
        // تحميل الملف من مجلد public
        const loadManifest = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                // Filter and map to extract keys with isActive = true
                var platformsTypes = data.platformsTypes || [];
                const activeKeys = platformsTypes
                    .filter((platform) => platform.isActive)
                    .map((platform) => platform.key);

                //console.log("Active keys:", activeKeys);

                setPlatformTypes(activeKeys);

            } catch (error) {
                console.error("Error loading manifest.json:", error);
            }
        };

        loadManifest();
    }, []);

    const targetRef = useRef(null);
    const targetRefAdditional = useRef(null);// Ref to the target area
    const [arrowPosition, setArrowPosition] = useState({ top: 50, left: 100 });
    const [isArrowVisible, setIsArrowVisible] = useState(false);
    // إخفاء السهم عند أي تفاعل (نقر أو تمرير)
    useEffect(() => {

        // if (VINDetails && brand) {
        //     if (targetRef.current) {
        //         const rect = targetRef.current.getBoundingClientRect();

        //         //console.log("targetRef", window.scrollX);
        //         setArrowPosition({
        //             top: rect.top + window.scrollY, // Adjust for scroll
        //             left: (rect.left == 0 ? 50 : rect.left) + window.scrollX, // Adjust for scroll
        //         });
        //     }
        //     setIsArrowVisible(true);
        //     const hideArrow = () => setIsArrowVisible(false);
        //     window.addEventListener("scroll", hideArrow);
        //     window.addEventListener("click", hideArrow);

        //     return () => {
        //         window.removeEventListener("scroll", hideArrow);
        //         window.removeEventListener("click", hideArrow);
        //     };
        // }

    }, [VINDetails, brand]);


    function handelalertIndicatorArrow(targetRef) {

        if (targetRef.current) {
            const rect = targetRef.current.getBoundingClientRect();

            //console.log("targetRef", window.scrollX);
            setArrowPosition({
                top: (rect.top - 30) + window.scrollY, // Adjust for scroll
                left: (rect.left == 0 ? 50 : rect.left) + window.scrollX, // Adjust for scroll
            });

            setIsArrowVisible(true);
            const hideArrow = () => setIsArrowVisible(false);
            window.addEventListener("scroll", hideArrow);
            window.addEventListener("click", hideArrow);

            return () => {
                window.removeEventListener("scroll", hideArrow);
                window.removeEventListener("click", hideArrow);
            };
        }
    }

    const [browser, setBrowser] = useState('');

    useEffect(() => {
        const userAgent = navigator.userAgent;

        if (userAgent.indexOf('Chrome') > -1) {
            setBrowser('Chrome');
        } else if (userAgent.indexOf('Firefox') > -1) {
            setBrowser('Firefox');
        } else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
            setBrowser('Safari');
        } else if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident') > -1) {
            setBrowser('Internet Explorer');
        } else if (userAgent.indexOf('Edge') > -1) {
            setBrowser('Edge');
        } else {
            setBrowser('Other');
        }
    }, []);

    useEffect(async () => {

        try {
            const response = await axios.request({
                baseURL: config.controllURL,
                url: lang + "/api/privacy/ProtectionAndShadingAgreement",
                method: "get",
            });
            setAgreements(response.data?.agreements);
        } catch (error) {
            //console.log(error);
        }
    }, []);

    useEffect(() => {
        const paymentStatus = new URL(window.location.href).searchParams.get("paymentStatus");
        const orderId = new URL(window.location.href).searchParams.get("orderId");

        const paymentMethodCallback = new URL(window.location.href).searchParams.get("PaymentMethod");
        const paymentTypeCallback = new URL(window.location.href).searchParams.get("PaymentType");
        if (paymentMethodCallback != null && paymentTypeCallback != null) {

            if (paymentMethodCallback.toLowerCase() == 'myfatoorah'.toLowerCase()) {
                StatusPaymentMyfatoorahSalesOrdersService();
            }
            else if (paymentMethodCallback.toLowerCase() == 'paytabs'.toLowerCase()) {
                StatusPaymentPayTabsSalesOrdersService();
            } else if (paymentMethodCallback.toLowerCase() == 'tabby'.toLowerCase()) {
                StatusPaymentTabbySalesOrdersService();

            } else if (paymentMethodCallback.toLowerCase() == 'tamara'.toLowerCase()) {
                if (paymentStatus == 'approved') {
                    StatusPaymentTamaraSalesOrdersService(orderId);
                    setTimeout(() => {

                        // StatusPaymentTamaraSalesOrdersService(orderId);

                    }, 2000);

                    setShowFinalPopup(true);
                }

            } else if (paymentMethodCallback === 'sadad') {
                StatusPaymentSadadSalesOrdersService();
                //site_fetchSadadCode_salesOrdersService
            } else {
                setIsSendeng(false);
                toast.error(trans("error:unknown_failure"));
            }

        }

    }, [])

    useEffect(() => {

        if (orderReservation) {
            setResOrderID(orderReservation?.MaintenanceOrderID);
            setShowFinalPopup(true);

        }
        fetchSettings();


        if (PVIN) {
            GetVINDetails(PVIN);
            FetchSalesInvoiceTrans(PVIN);
        }




    }, [PVIN, orderReservation])
    const [firstByLink22, setFirstByLink22] = useState(true);
    useEffect(() => {

        if (VINDetails && VINDetails.length > 0 && settings && settings?.groups?.length > 0 && firstByLink22 == true) {

            setFirstByLink22(false);
            PGroupID = VINDetails[0].CarGroup;
            PYear = VINDetails[0].Model;
            let PBrandID = VINDetails[0].BrandID;
            let ttmodelType = VINDetails[0].Type;


            setRequestForm({
                ...requestForm,
                name: lang == "ar" ? VINDetails[0].CustNameAr : VINDetails[0].CustNameEn,
                phone: VINDetails[0].Mobile,
                email: VINDetails[0].Email,
                myCarID: VINDetails[0].VIN
            });

            setTimeout(() => {
                handleServiceOrder({
                    showPopup: true,
                    type: "sub2",
                    main: "B56D30C7-3AA6-4698-A640-6F392138CB24",
                    sub1: "635F9201-A9F5-404D-9A9A-FD537F32B5A0",
                    sub2: "A82C0550-2A18-44EA-B466-7343BFC45340",
                    ServiceID: PServiceID,
                    brand: PBrandID,
                    group: PGroupID,
                    year: PYear,
                    modelType: ttmodelType,
                    name: lang == "ar" ? VINDetails[0].CustNameAr : VINDetails[0].CustNameEn,
                    phone: VINDetails[0].Mobile,
                    email: VINDetails[0].Email,
                    myCarID: VINDetails[0].VIN,

                });
            }, 2000);


        }

    }, [PGroupID, PYear, settings, VINDetails, orderReservation])

    async function FetchSalesInvoiceTrans(VIN) {
        const Body = {
            "VIN": VIN
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_FetchSalesInvoiceTransProtectionServiceByVIN`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                ////console.log("App_GetVINDetails:", response.data);
                var productList = response?.data?.map(s => s.ProductID);
                setSalesInvoiceTrans(productList);
            })
            .catch(function (error) {

                //console.log(error);
                setSalesInvoiceTrans([]);
            });


    }
    async function GetVINDetails(VIN) {



        const Body = {
            "VIN": VIN,
            "UserId": PUser
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/App_GetVINDetailsByUserId`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                ////console.log("App_GetVINDetails:", response.data);
                setVINDetails(response.data);
            })
            .catch(function (error) {

                //console.log(error);
                setVINDetails([]);
                setShowFinalPopupMessage(trans("employment:The_page_link_is_incorrect"));
                setShowFinalPopup(true);
            });


    }

    useEffect(() => {

        function handleClickOutside(event) {
            if (popRef.current && !popRef.current.contains(event.target) && showFinalPopup === true) {
                setShowFinalPopup(false);
                setResOrderID(null);
                if (location.pathname)
                    history.push(location.pathname);

            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFinalPopup]);


    //--------------------------------------------------
    const [maintenanceObj, setMaintenanceObj] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });
    const [Defult, setDefult] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });



    const notLoginSchema = Joi.object({
        name: Joi.string().required().messages(GetMessages()),
        year: Joi.string().required().messages(GetMessages())
    });




    const handleFilteredModels = (option) => {

        setModelCode(vModelCode[option]);
        setGroup(null);
        setType(null);
        setFilteredSettings({ ...filteredSettings, models: [], productModels: [] });
        setGroup(option);

        var fModels = [];
        try {
            const currentgroupData = settings?.groups?.filter(a => a.brandID == brand && a.productGroupID == option);


            const ListTreeGroups = (currentgroupData && currentgroupData?.length > 0) ? currentgroupData[0].ListTreeGroups : option;
            // Split the comma-separated string into an array
            const listVArray = ListTreeGroups.split(',');

            // Assuming settings.productModels is an array of objects with properties productGroupID and Model
            fModels = settings?.productModels?.filter(a =>
                listVArray.includes(a.productGroupID)
            );


        } catch {

            fModels = settings?.productModels?.filter(a => a.productGroupID == option);
        }


        setFilteredSettings({ ...filteredSettings, productModels: fModels });

    };

    const handelSelectBrand = (option, vYear = year) => {
        setBrand(null);
        setGroup(null);
        setType(null);

        setFilteredSettings({ ...settings, groups: [], models: [], productModels: [] });

        setBrand(option);


        const fGroups = settings?.groups?.filter(a => a.brandID == option && a.Year == vYear);

        setFilteredSettings({ ...settings, groups: fGroups, models: [], productModels: [] });


    };


    useEffect(() => {

        if (settings?.brands && settings?.brands.length > 0 && Defult?.first != true
        ) {
            if (Defult?.year) {
                setYear(Defult?.year)
                const val = { ...requestForm };
                val.year = Defult?.year;
                setRequestForm(val);
            }
            if (Defult?.brand)
                handelSelectBrand(Defult?.brand, Defult?.year);
        }

    }, [Defult, settings]);


    useEffect(() => {

        try {

            if (requestForm?.date) {

                var md = new Date(requestForm?.date);
                try {
                    if (requestForm?.time) {

                        var Hours = requestForm?.time.split(":");

                        md.setHours(Hours[0], Hours[1], 0);
                    }
                } catch (error) {

                }


            }

        } catch (error) {
        }


    }, [requestForm]);

    useEffect(() => {


        if (settings?.brands && settings?.brands.length > 0 && filteredSettings?.groups?.length > 0 && Defult?.first != true) {

            setDefult({ ...Defult, first: true });
            if (Defult?.group)
                handleFilteredModels(Defult?.group);

            if (Defult?.modelType) {
                setType(Defult?.modelType);
            }
        }
    }, [filteredSettings]);



    const fetchSettings = async () => {
        try {

            if ("caches" in window) {
                var curl = "Settings-" + lang;

                // Opening that particular cache
                const cacheStorage = await caches.open("HJWeb");

                // Fetching that particular cache data
                const cachedResponse = await cacheStorage.match(
                    curl
                );
                var settingResponseCash = await cachedResponse?.json();

                const currentSettings = { ...settings };
                currentSettings.brands = settingResponseCash?.brands;
                currentSettings.groups = settingResponseCash?.groups;
                currentSettings.models = settingResponseCash?.models;
                currentSettings.productModels = settingResponseCash?.productModels;
                setSettings(currentSettings);

                const fGroups = currentSettings?.groups?.filter(a => a.brandID == brand);

                //---------------------------------------------------------------
                let currentvModelCode = {};
                currentSettings?.productModels?.map((item) => {
                    if (item.ModelCode) {
                        currentvModelCode[item.productGroupID] = item.ModelCode;
                    }
                })
                setVModelCode(currentvModelCode);
            }


            const settingResponse = await axios.request({
                baseURL: '/',
                url: config.controllURL + lang + "/api/Maintenance/Settings",
                method: "get"
            });

            const currentSettings = { ...settings };
            currentSettings.brands = settingResponse.data?.brands;
            currentSettings.groups = settingResponse.data?.groups;
            currentSettings.models = settingResponse.data?.models;
            currentSettings.productModels = settingResponse.data?.productModels;

            setSettings(currentSettings);

            const fGroups = currentSettings?.groups?.filter(a => a.brandID == brand);

            //---------------------------------------------------------------

            let currentvModelCode = {};
            currentSettings?.productModels?.map((item) => {
                currentvModelCode[item.productGroupID] = item.ModelCode

            })

            ////////console.log("currentvModelCode>>>>>>>>>", currentvModelCode);
            setVModelCode(currentvModelCode);

            const data = new Response(JSON.stringify(settingResponse.data));

            if ("caches" in window) {
                // Opening given cache and putting our data into it
                caches.open("HJWeb").then((cache) => {
                    cache.put("Settings-" + lang, data);

                });
            }

        } catch (error) {
            ////////console.log(error);
        }

    };
    const handleServiceOrder = (data) => {

        try {
            data['firstFetchPrice'] = null;
            data['first'] = null;
            setStepNum(1);
            setDataFullNum(0);


            setinfoPrice([{ Price: 0 }]);

            const value = { ...maintenanceObj, ...data };
            if (data?.main == '') {

                data['main'] = null;
            }
            if (data?.sub1 == '') {

                data['sub1'] = null;
            }
            if (data?.sub2 == '') {

                data['sub2'] = null;

            }

            setDefult(data);

            var sub2 = { value: data.sub2, ServiceID: data?.ServiceID }
            fetchService(sub2);



            setTimeout(() => {

                setMaintenanceObj(value)

            }, 2000);


        } catch (e) {
            console.error(e)

        }

    };
    const [Note, setNote] = useState("");

    const [lodingService, setLodingService] = useState(false);

    const [Branches, setBranches] = useState([]);
    let [modelCode, setModelCode] = useState("");
    const [ServiceID, setServiceID] = useState(null);
    const [allServiceID, setAllServiceID] = useState([]);
    const [Service, setService] = useState(null);
    const [serviceImportantAdditions, setServiceImportantAdditions] = useState(null);
    async function fetchService(option) {
        setService([]);
        setinfoPrice([{ Price: 0 }]);

        setLodingService(true);


        const Body = {
            "VehicleType": VINDetails && VINDetails.length > 0 ? VINDetails[0].VehicleType : ""
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_FetchProtectionServiceByVehicleType_forNewCar`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // ////////console.log(response.data.ApiObjectData);
                // selectService[lang == "ar" ? "ServiceDetails" : "ServiceDetailsEn"]?.includes("Tinting")
                // var filterservice = response?.data?.filter(s => !s.ServiceDetails?.includes("تلميع") && !s.ServiceDetails?.includes("الصغيرة") && !s.ServiceDetails?.includes("الصغيره"))
                var filterservice = response?.data;
                setTimeout(setService(filterservice), 1000);
                var newServiceImportantAdditions = filterservice.find(s => (s["ServiceDetailsEn"].includes("rust") || s["ServiceDetailsEn"]?.includes("Undercoating")
                    || s["ServiceDetails"]?.includes("عازل صد")));
                setServiceImportantAdditions(newServiceImportantAdditions);
                if (option?.ServiceID) {
                    setServiceID(option?.ServiceID)
                    const val = { ...requestForm };
                    val.ServiceID = option?.ServiceID;
                    setRequestForm(val);
                    filterservice.map((B) => {
                        if (B.ServiceID === option?.ServiceID) {
                            const v = selsub0;
                            v.desAr = B.ServiceNameAR;
                            v.desEn = B.ServiceName;
                            v.ID = B.ServiceID;
                            setselsub0(v);
                            //////////console.log(v);
                        }
                    })
                }

                setLodingService(false);

            })
            .catch(function (error) {

                setLodingService(false);
                ////////console.log(error);
            });



    }
    async function FetchPrice(modelC, SID) {

        setinfoPrice([{ Price: 0 }]);
        if (!modelC) {
            return;
        }
        if (!SID) return;



        const Body = {
            "ModelCode": modelC,
            "ServicID": SID
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/Site_fetchPriceService`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // ////////console.log(response.data.ApiObjectData);

                setinfoPrice(response.data);

            })
            .catch(function (error) {
                setinfoPrice([{ Price: 0 }]);

                ////////console.log(error);
            });


    }

    const checkDataFullNum = async () => {

        if (group && paymentType && allServiceID && allServiceID.length > 0 && requestForm?.name) {

            setDataFullNum(2);
            return 2;
        } else if (group && paymentType && allServiceID && allServiceID.length > 0 && requestForm?.name) {

            setDataFullNum(2);
            return 2;
        } else {
            setDataFullNum(0);
            return 0;
        }


    }

    //--------------------------
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    // Function to show the popup and wait for the user's response
    const showConfirmationPopup = () => {
        return new Promise((resolve) => {
            setIsPopupOpen(true);
            //console.log("showConfirmationPopup>>>>>>>>>>>.11111111111111111111");

            setTimeout(() => {
                handelalertIndicatorArrow(targetRefAdditional);
            }, 500);
            // If user clicks OK, resolve the promise with true
            const handleConfirm = (data) => {
                // setIsPopupOpen(false);
                resolve(data);

                //console.log("handleConfirm");
            };

            // If user clicks Cancel, resolve the promise with false
            const handleCancel = (data) => {
                setIsPopupOpen(false);
                resolve(false);

                //console.log("handleCancel");
            };

            // Assign confirm and cancel handlers to the popup props
            setPopupHandlers({ onConfirm: handleConfirm, onCancel: handleCancel });
        });
    };

    const [popupHandlers, setPopupHandlers] = useState({
        onConfirm: null,
        onCancel: null,
    });

    //---------------------
    const scrollToArticle = (id) => {

        try {
            const element = document.getElementById(id);
            if (element) {
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset; // موضع العنصر بالنسبة للصفحة
                const offset = elementPosition - window.innerHeight / 2; // ضبط ليكون العنصر في منتصف الشاشة

                window.scrollTo({
                    top: offset,
                    behavior: 'smooth', // تمرير ناعم
                });
            }
        } catch (error) {

        }



    };

    const [error, setError] = useState({});
    async function SendResreve(VIN, ServecID, UserID, Amount) {


        const val = { ...requestForm };
        val.year = year;
        val.ServiceID = ServiceID;
        setRequestForm(val);
        var mainNote = Note;
        const result = formValidate(notLoginSchema, val) ?? {};

        const hasTintingService = allselectServices.find(s => allServiceID.includes(s.ServiceID) && (s?.text?.includes("تظليل") || s?.text?.includes("Tinting") || s["ServiceDetailsEn"]?.includes("tinting")
            || s["ServiceDetails"]?.includes("تظليل")));


        var noteTinting = "";
        if (hasTintingService) {

            if (isToggleSwitch == false) {
                if (evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0] == null || evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0] === "") {
                    noteTinting += "\\nزجاج امامي:" + "0";

                } else {
                    noteTinting += "\\nزجاج امامي:" + evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0];
                }
                if (evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 1] == null || evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 1] === "") {
                    result[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 1] = trans("الاختيار اجباري");
                    setActiceMenu(hasTintingService?.MainWebGroup);
                    setIndexPanel(hasTintingService?.ServiceID);
                    setActiceService(hasTintingService);
                    scrollToArticle(hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 1);
                } else {
                    noteTinting += "\\nزجاج خلفي:" + evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 1];
                }
                if (evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 2] == null || evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 2] === "") {
                    result[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 2] = trans("الاختيار اجباري");
                    setActiceMenu(hasTintingService?.MainWebGroup);
                    setIndexPanel(hasTintingService?.ServiceID);
                    setActiceService(hasTintingService);
                    scrollToArticle(hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 2);
                } else {
                    noteTinting += "\\nزجاج جانبي امامي:" + evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 2];
                }
                if (evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 3] == null || evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 3] === "") {
                    result[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 3] = trans("الاختيار اجباري");
                    setActiceMenu(hasTintingService?.MainWebGroup);
                    setIndexPanel(hasTintingService?.ServiceID);
                    setActiceService(hasTintingService);
                    scrollToArticle(hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 3);
                } else {
                    noteTinting += "\\nزجاج جانبي خلفي:" + evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 3];
                }



            } else {

                if (evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0] == null || evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0] === "") {
                    result[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0] = trans("الاختيار اجباري");
                    setActiceMenu(hasTintingService?.MainWebGroup);
                    setIndexPanel(hasTintingService?.ServiceID);
                    setActiceService(hasTintingService);
                    scrollToArticle(hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0);
                } else {
                    noteTinting += "\\n كامل زجاج السياره:" + evaluations[hasTintingService?.ServiceID + "_" + isToggleSwitch + "_" + 0];
                }
            }

        }

        //console.log(">>>>>>>>>>>>>>>>>result", result)
        setError(result);

        if (Object.keys(result).length == 0 && isSendeng == false) {

            //console.log(">>>>>>>>>>>>>>>>>go to showConfirmationPopup", isSendeng)
            const userConfirmed = await showConfirmationPopup(); // Wait for user response

            //console.log(">>>>>>>>>>>>>>>>>showConfirmationPopup:", userConfirmed)
            if (userConfirmed) {
                let listofServices;
                // allServiceID
                userConfirmed?.map((item) => {

                    if (listofServices)
                        listofServices += "," + item;
                    else
                        listofServices = item;
                });

                setIsSendeng(true);
                mainNote += noteTinting;
                try {
                    var myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    var raw = {
                        "paytype": paymentType,
                        "userId": PUser,
                        "VIN": VIN,
                        "note": mainNote,
                        "servicelist": listofServices,
                        "referenceOrderId": pSalesorderid,
                        "callback": window.location.origin + "/" + lang + `/maintenance/ProtectionAndShading/${VIN}${PUser ? '/' + PUser : ''}`
                    };

                    // console.log("raw>>>>>>>>>>>>>>>>:", raw);
                    await axios.request({
                        baseURL: config.controllURL,
                        url: "api/Payment/applyPaymentSalesOrdersService",
                        headers: myHeaders,
                        data: raw, method: "POST", responseType: "json"
                    })

                        .then(async response => {
                            //console.log('Payment respons data:\n', response.data);


                            if (response.data.URL_Paytabs) {
                                window.location.href = response.data.URL_Paytabs;

                            } else if (response.data.url_payment) {
                                window.location.href = response.data.url_payment;
                                //site_fetchSadadCode_salesOrdersService
                            } else {
                                setIsSendeng(false);
                                if (response?.data?.MessageError) {

                                    if (paymentType == 'tabby') {
                                        setMessageError(response.data.MessageError);
                                    } else {
                                        toast.error(response?.data?.MessageError);
                                    }


                                }
                                else
                                    toast.error(trans("error:unknown_failure"));
                            }



                            setIsPopupOpen(false);
                            setIsSendeng(false);
                        })
                        .catch(function (error) {
                            setIsPopupOpen(false);
                            setIsSendeng(false);
                        });

                } catch (error) {
                    setIsSendeng(false);
                    setIsPopupOpen(false);
                    //console.log("error:", error);
                }
            } else {
                //console.log('Operation canceled.');
                setIsPopupOpen(false);
                // Do nothing or handle cancellation here
            }
        }
    }



    async function StatusPaymentTamaraSalesOrdersService(orderId) {
        if ((paramGUID || paramJobCardGUID) && orderId) {
            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "GUID": paramGUID,
                    "orderId": orderId ?? "",
                    "JobCardGUID": paramJobCardGUID
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/StatusPaymentTamaraSalesOrdersService",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    //console.log('StatusPaymentTamaraSalesOrdersService respons:', response);
                    if (response.data) {

                        var data = response.data;
                        console.log('PaymentPaytabsStatusFully data:', data);
                        if (data.Status == "success") {
                            setShowFinalPopup(true);
                            if (data.OrderId)
                                setResOrderID(data.OrderId);
                        }
                    }


                }
                ).catch(async error => {
                    //console.log('error StatusPaymentTamaraSalesOrdersService:', error)

                });
            } catch (error) {
                //console.log('error', error)


            }
        }
    }
    async function StatusPaymentTabbySalesOrdersService() {
        const payment_id = new URL(window.location.href).searchParams.get("payment_id");
        console.log("paramGUID:", paramGUID)
        console.log("paramJobCardGUID:", paramJobCardGUID)
        console.log("orderpayment_idId:", payment_id)
        if ((paramGUID || paramJobCardGUID)
            //&& payment_id
        ) {
            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "GUID": paramGUID,
                    "orderId": payment_id ?? "",
                    "JobCardGUID": paramJobCardGUID
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/StatusPaymentTabbySalesOrdersService",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    //console.log('StatusPaymentTamaraSalesOrdersService respons:', response);

                    try {
                        var data = response.data;
                        if (response.status >= 200 && response.status <= 300 && response?.data?.Status == 'success') {

                            setShowFinalPopup(true);
                            if (data.OrderId)
                                setResOrderID(data.OrderId);
                        } else if (response.status >= 300 && response.status <= 400) {

                            toast.error(trans("error:unknown_failure") + ' ' + response.status);

                        } else {


                        }
                    } catch (ex) {
                        toast.error(trans("error:unknown_failure") + ' ' + response.status);
                    }
                }
                ).catch(async error => {
                    //console.log('error StatusPaymentTamaraSalesOrdersService:', error)

                });
            } catch (error) {
                //console.log('error', error)


            }
        }
    }
    async function StatusPaymentMyfatoorahSalesOrdersService() {
        //console.log('StatusPaymentMyfatoorahSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');

        if (paramGUID || paramJobCardGUID) {



            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "GUID": paramGUID,
                    "JobCardGUID": paramJobCardGUID
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/StatusPaymentMyfatoorahSalesOrdersService",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    //console.log('PaymentMyfatoorahStatusFully respons:', response);
                    if (response.data && response.data.length > 0) {

                        var data = response.data.filter(p => p.Status == "success")[0];
                        //console.log('PaymentMyfatoorahStatusFully data:', data);
                        if (data.Status == "success") {
                            setShowFinalPopup(true);
                            if (data.OrderId)
                                setResOrderID(data.OrderId);
                        }
                    }

                }
                ).catch(async error => {
                    //console.log('error PaymentMyfatoorahStatusFully:', error)

                });
            } catch (error) {
                //console.log('error', error)


            }
        }
    }
    async function StatusPaymentPayTabsSalesOrdersService() {
        //console.log('StatusPaymentPayTabsSalesOrdersService >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>');

        if (paramGUID) {



            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "GUID": paramGUID,
                    "JobCardGUID": paramJobCardGUID
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/StatusPaymentPayTabsSalesOrdersService",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    //console.log('PaymentPaytabsStatusFully respons:', response);
                    if (response.data && response.data.length > 0) {

                        var data = response.data.filter(p => p.Status == "success")[0];
                        //console.log('PaymentPaytabsStatusFully data:', data);
                        if (data.Status == "success") {
                            setShowFinalPopup(true);
                            if (data.OrderId)
                                setResOrderID(data.OrderId);
                        }
                    }

                }
                ).catch(async error => {
                    //console.log('error PaymentPaytabsStatusFully:', error)

                });
            } catch (error) {
                //console.log('error', error)


            }
        }
    }
    async function StatusPaymentSadadSalesOrdersService() {
        //console.log('StatusPaymentSadadSalesOrdersService >>>>>>>', paramGUID);

        if (paramGUID) {



            try {
                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                var raw = {
                    "GUID": paramGUID
                };

                await axios.request({
                    baseURL: config.controllURL,
                    url: "api/Payment/StatusPaymentSadadSalesOrdersService",
                    headers: myHeaders,
                    data: raw, method: "POST", responseType: "json"
                }).then(async response => {
                    //console.log('StatusPaymentSadadSalesOrdersService respons:', response);

                    var invoiceID = response.data.sadadNumber.replaceAll('"', "");

                    try {
                        if (invoiceID && parseInt(invoiceID)) {
                            var datasadad = response.data;
                            datasadad.sadadNumber = invoiceID;
                            setSadadInfo(datasadad);
                        } else {
                            setSadadInfo(response?.data);
                        }
                    } catch (error) {
                        setSadadInfo(response.data);
                    }
                    //! اهمم مرحلة في الفحص
                    if (invoiceID != null && invoiceID != undefined) {
                        setShowFinalPopup(true);
                    }

                }
                ).catch(async error => {
                    //console.log('error StatusPaymentSadadSalesOrdersService:', error)

                });
            } catch (error) {
                //console.log('error', error)


            }
        }
    }
    useEffect(() => {

        if (Branches && Branches?.length > 0 && !requestForm?.SiteID) {

            if (Branches?.length == 1) {
                let val = {};
                val.SiteID = Branches[0]?.SiteID;
                setRequestForm({ ...requestForm, ...val });
            }

        }

    }, [Branches, requestForm]);


    useEffect(() => {
        checkDataFullNum();
    }, [requestForm, ServiceID, allServiceID, year, type, paymentType]);



    useEffect(() => {
        if (vModelCode != null && ServiceID && Defult?.firstFetchPrice != true) {
            setDefult({ ...Defult, firstFetchPrice: true });
            if (Defult?.modelType) {
                if (vModelCode[Defult?.modelType] && ServiceID)
                    FetchPrice(vModelCode[Defult?.modelType], ServiceID);
            }



        }

    }, [vModelCode, ServiceID]);



    return (
        <>

            {
                (VINDetails && brand) ?

                    <div className={"protection-and-shading   " + (brand == 1 ? " toyota-theme " : " lexus-theme ")} >

                        {/* <div className="protection-and-shading-top" >
                    <button
                        onClick={() => {

                            if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {

                                if (window.location.href.includes("/en"))
                                    window.location = window.location.href.replace("/en", "/ar");
                                if (window.location.href.includes("/ar"))
                                    window.location = window.location.href.replace("/ar", "/en");

                            } else {

                                window.location = window.location.origin + "/en" + window.location.pathname;
                            }
                        }}
                        className="protection-and-shading-top-lang h-full  flex justify-center items-center">

                        <span className='text-white font-bold pl-2 pr-2 capitalize'>{trans('common:changeLangCode')}</span>
                        <img src="/assets/icons/globle.svg" alt="change language" />
                    </button>
                </div> */}
                        <div className="protection-and-shading-head" >
                            <div className="protection-and-shading-head-Logo">

                                {
                                    lang == "ar" ?

                                        <div className="res-Logo-icon ">
                                            <img src="/assets/logo/logo_font_Black_AR.svg"
                                                alt="hassan jameel" className="hidden d-md-inline" />
                                            <img src="/assets/logo/logo_font_Black_AR.svg"
                                                alt="hassan jameel" className="d-inline d-md-hidden" />
                                        </div>


                                        :

                                        <div className="res-Logo-icon ">
                                            <img src="/assets/logo/logo_font_Black_EN.svg"
                                                alt="hassan jameel" className="hidden d-md-inline" />
                                            <img src="/assets/logo/logo_font_Black_EN.svg"
                                                alt="hassan jameel" className="d-inline d-md-hidden" />
                                        </div>
                                }
                            </div>

                            <div className="protection-and-shading-head-extra flex flex-worp">
                                <div className="protection-and-shading-head-brand flex flex-worp">
                                    {
                                        (brand == 1) ?
                                            <>
                                                <img src={`/assets/icons/brands/${"toyota-logo-withName.png"}`}
                                                    className="" alt={brand} />
                                            </>
                                            :
                                            (
                                                (brand == 2) ?
                                                    <>
                                                        <img src={`/assets/icons/brands/${"lexus-logo-withName.png"}`}
                                                            className="" alt={brand} />
                                                    </>
                                                    :
                                                    null

                                            )

                                    }
                                </div>

                                <button
                                    onClick={() => {

                                        if (window.location.href.includes("/ar") || window.location.href.includes("/en")) {

                                            if (window.location.href.includes("/en"))
                                                window.location = window.location.href.replace("/en", "/ar");
                                            if (window.location.href.includes("/ar"))
                                                window.location = window.location.href.replace("/ar", "/en");

                                        } else {

                                            window.location = window.location.origin + "/en" + window.location.pathname;
                                        }
                                    }}
                                    className="protection-and-shading-top-lang h-full  flex justify-center items-center">

                                    <span className='text-white font-bold pl-2 pr-2 capitalize'>{trans('common:changeLangCode')}</span>
                                    <img src="/assets/icons/globle.svg" alt="change language" />
                                </button>
                            </div>


                        </div >
                        {/* <div className="reservation-head-sub">
                {
                    lang == "ar" ?

                        <h1 className="text-balck text-bold text-20 text-center">لعمر افتراضي أطول، حافظ على سيارتك</h1>
                        :
                        <h1 className="text-balck text-bold text-20 text-center">For longer longevity, maintain your vehicle </h1>
                }

            </div> */}



                        <div className="protection-and-shading-titel nice-container nice-relative">
                            <div className=" p-4">
                                <div className="mainteance-popup-container-header py-5 flex flex-col ">
                                    <h3 className="text-balck text-bold text-40 my-5 ">
                                        {trans("info:Pamper_your_car_and_dont_skimp_on_it")}</h3>
                                    <p className="protection-and-shading-titel-sub1 text-24 text-bold ">{trans("info:Congratulations_on_your_new_car") +
                                        (requestForm?.name?.split(' ')[0] ? (lang == "ar" ? " يا" : ",") + requestForm.name.split(' ')[0] : " ")}</p>
                                    <p className="protection-and-shading-titel-sub2 text-24 text-bold ">{trans("info:These_are_some_additional_services_to_protect_the_car")}</p>

                                    <div className='nice-flex-row my-5'>
                                        <div className='text-12 text-sub-color'>
                                            {trans("vehicales:veh-struc")} : {PVIN}
                                        </div>
                                    </div>

                                    {/* <div className="reservation-brand-Logo">
                            {
                                (brand == 1) ?

                                    <img src={`/assets/icons/brands/${"toyota"}.png`}
                                        alt={brand} onError={e => e.target.style.display = 'none'} />
                                    :
                                    (
                                        (brand == 2) ?
                                            <img src={`/assets/icons/brands/${"lexus-black"}.png`}
                                                alt={brand} onError={e => e.target.style.display = 'none'} />
                                            :
                                            null

                                    )

                            }
                        </div> */}
                                </div>

                                {/* <div className="my-8  flex flex-col nice-gap-2rem ">
                        {
                            stepNum == 1 &&
                            <>

                                {
                                    <>
                                        <div className="flex flex-row grid-2-cols nice-gap-2rem ">

                                            <div className="basis-2/4 grow">

                                                <InputField
                                                    disabled={true}
                                                    errorLabel={error?.name}
                                                    placeholder={trans("form:name")}
                                                    value={requestForm.name}
                                                    length={255}
                                                    onChangeValue={
                                                        (e) => {
                                                            const val = {};
                                                            val.name = e.target.value;
                                                            setRequestForm({ ...requestForm, ...val });
                                                        }
                                                    }
                                                />
                                            </div>


                                        </div>
                                        <div className="flex flex-row grid-3-cols-importent nice-gap-2rem ">
                                            <div className="basis2/4 grow">


                                                <InputField
                                                    disabled={true}
                                                    errorLabel={error?.brand}
                                                    placeholder={trans("info:company")}
                                                    value={settings?.brands?.filter(g => g.brandID == brand)[0]?.description}
                                                    length={255}
                                                    onChangeValue={
                                                        (e) => {

                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="basis2/4 grow">


                                                <InputField
                                                    disabled={true}
                                                    errorLabel={error?.group}
                                                    placeholder={trans("eparts:vehicle")}
                                                    value={settings?.groups?.filter(g => g.productGroupID == group)[0]?.description}
                                                    length={255}
                                                    onChangeValue={
                                                        (e) => {

                                                        }
                                                    }
                                                />
                                            </div>

                                            <div className="basis2/4 grow">

                                                <InputField
                                                    disabled={true}
                                                    errorLabel={error?.year}
                                                    placeholder={trans("info:created_year")}
                                                    value={year}
                                                    length={255}
                                                    onChangeValue={
                                                        (e) => {

                                                        }
                                                    }
                                                />
                                            </div>

                                        </div>


                                    </>

                                }
                            </>
                        }

                        {
                            <div className="flex flex-row grid-1-cols-importent nice-gap-2rem ">


                                {
                                    // Service &&
                                    // <DropDownInput
                                    //     options={[
                                    //         ...Service?.map(B => {
                                    //             return { value: B.ServiceID, text: lang === 'ar' ? B.ServiceNameAR : B.ServiceName, ...B };
                                    //         })]}
                                    //     errorLabel={error?.ServiceID}
                                    //     onfilter={(option) => {

                                    //         const val = { ...requestForm };
                                    //         val.ServiceID = option.value;
                                    //         setRequestForm(val);

                                    //         setServiceID(null);
                                    //         setServiceID(option.value);
                                    //         setSelectService(option);
                                    //         FetchPrice(modelCode, option.value);

                                    //     }}
                                    //     isepart={true}
                                    //     isLoading={lodingService}
                                    //     selectedValue={ServiceID ? ServiceID : requestForm?.ServiceID}
                                    //     defaultOption={{ value: selsub0.ID, text: trans("info:servce") }}

                                    // />

                                    // <InputField
                                    //     isLoading={lodingService}
                                    //     disabled={true}
                                    //     errorLabel={error?.ServiceID}
                                    //     placeholder={trans("info:servce")}
                                    //     value={lang === 'ar' ? Service?.ServiceNameAR : Service?.ServiceName}
                                    //     length={255}
                                    //     onChangeValue={
                                    //         (e) => {
                                    //             const val = {};
                                    //             val.ServiceID = e.target.value;
                                    //             setRequestForm({ ...requestForm, ...val });
                                    //         }
                                    //     }
                                    // />
                                }


                            </div>

                        }
                    </div> */}
                            </div>

                        </div >



                        {
                            Service &&
                            <div ref={targetRef} className="protection-and-shading-menu more-services bg-secondary-lighter border-radius py-2 alert-indicator-target-area">
                                <div className=" pb-10 my-5">
                                    {/* menu tabs */}
                                    <div className="my-10 nice-apply-theme ">
                                        <Swiper
                                            spaceBetween={3}
                                            slidesPerView={3}
                                            breakpoints={{
                                                576: {
                                                    slidesPerView: 3,
                                                },
                                            }}
                                            className={" my-8  nice-apply-theme"}
                                            resizeObserver={"true"}
                                        >

                                            {[{ name: "الباقات التوفيرية", id: "Saving Packages" }, { name: "الحماية والتظليل", id: "Protection And Shading" }, { name: "خدمات خاصة", id: "Special Services" }]?.map((_val, _index) => {
                                                return (

                                                    <SwiperSlide key={_index} className={""}>
                                                        <div className='flex h-100' onClick={() => {
                                                            setActiceService(null);
                                                            setActiceMenu(_val.id);
                                                            setIndexPanel(null);
                                                        }}>

                                                            <div className={'protection-and-shading-menu-item nice-apply-theme bg-theme-up text-center bg-white ' + (acticeMenu == _val.id ? " active " : "  ")}>
                                                                <h3 className="protection-and-shading-menu-item-titel ">{lang == "ar" ? _val.name : _val.id} </h3>
                                                            </div>

                                                            {/* <div className='border-box-periodic-checkInput'>
                                                    <CheckInput
                                                        className="text-primary cursor-pointer"
                                                        oncheng={async (target) => {
                                                            const isChecked = target.checked;

                                                            if (isChecked) {
                                                                // Add the service to the lists
                                                                setAllSelectServices(prevServices => [...prevServices, _val]);

                                                                setAllServiceID(prevServiceIDs => [...prevServiceIDs, _val.ServiceID]);
                                                            } else {
                                                                // Remove the service from the lists
                                                                setAllSelectServices(prevServices =>
                                                                    prevServices.filter(service => service !== _val)
                                                                );

                                                                setAllServiceID(prevServiceIDs =>
                                                                    prevServiceIDs.filter(id => !_val.ServiceID.includes(id))
                                                                );
                                                            }

                                                        }}
                                                        Name={"23-44"}
                                                    >
                                                    </CheckInput>
                                                </div>
                                                <CustomItemServices
                                                    // title={trans("mobileCommon:finance")}
                                                    title={lang == "ar" ? _val.ServiceNameAR : _val.ServiceName}
                                                    borderCSS={_val.ServiceID == acticeService?.ServiceID ? "border-primary-box padding-inline-start-3" : " padding-inline-start-3 "
                                                    }
                                                /> */}
                                                        </div>
                                                    </SwiperSlide>

                                                );
                                            })}



                                        </Swiper>
                                    </div>
                                    {/* body */}
                                    <div className="flex flex-col  nice-relative ">
                                        {
                                            Service?.filter(s => s.MainWebGroup == acticeMenu).map((_Srtvice, _index) => {
                                                return (
                                                    <div key={_index} className="panel-section mx-5">

                                                        {
                                                            SalesInvoiceTrans.includes(_Srtvice.ServiceID) &&
                                                            <div className="panel-section-overlay">

                                                            </div>
                                                        }

                                                        <div className={`panel-content  ${(indexPanel == _Srtvice.ServiceID) ? "show-panel-info" : ""}`}>
                                                            <div className="panel-content-top"

                                                                onClick={(e) => {
                                                                    setIndexPanel(null);
                                                                    setActiceService(null);
                                                                    if (indexPanel != _Srtvice.ServiceID) {
                                                                        setIndexPanel(_Srtvice.ServiceID);
                                                                        setActiceService(_Srtvice);
                                                                    }


                                                                }}


                                                            >
                                                                <div className="protection-and-shading-menu-servie">
                                                                    <h1 className={"text-20    font-bold " + (SalesInvoiceTrans.includes(_Srtvice.ServiceID) ? " text-gray " : " text-super-gray ") + (allServiceID.includes(_Srtvice.ServiceID) ? " selectd " : "")}>
                                                                        {lang == "ar" ? _Srtvice.ServiceNameAR : _Srtvice.ServiceName}</h1>

                                                                    <div className='protection-and-shading-menu-price flex flex-row gap-2 text-bold nice-justifiy-end text-24'>

                                                                        {
                                                                            _Srtvice?.PriceExcludeTax && <Price price={_Srtvice?.PriceExcludeTax} />
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <img src="/assets/icons/arrow.svg" />
                                                            </div>

                                                            <div className="panel-content-body">

                                                                <ul>
                                                                    {
                                                                        _Srtvice[lang == "ar" ? "ServiceDetails" : "ServiceDetailsEn"]?.replaceAll("\\n\\n", "\\n")?.split('\n')?.map((note, index) => {

                                                                            return (

                                                                                note ?
                                                                                    <li key={index} className="text-16 text-gray"  >
                                                                                        {/* <span className="text-16 text-gray" >{note}</span> */}
                                                                                        <span className="text-16 text-gray" dangerouslySetInnerHTML={{ __html: note }} />
                                                                                    </li>
                                                                                    : null

                                                                            );
                                                                        })
                                                                    }


                                                                </ul>




                                                                {
                                                                    acticeService && (acticeService?.text?.includes("تظليل") || acticeService?.text?.includes("Tinting") || acticeService["ServiceDetailsEn"]?.includes("tinting")
                                                                        || acticeService["ServiceDetails"]?.includes("تظليل")) &&
                                                                    <div className="flex flex-row grid-1-cols-importent nice-gap-2rem my-20">
                                                                        <div className="flex flex-col">
                                                                            <div className="flex nice-flex-space-between">
                                                                                <div className='text-30 flex nice-gap-2rem'>
                                                                                    <span className='text-20 text-bold flex'>{trans('info:Degree_of_shading')}</span>
                                                                                </div>


                                                                                <div className="flex flex-col nice-align-item-center">

                                                                                    <div className="toggle-switch">
                                                                                        <input type="checkbox" id="switch-2"
                                                                                            className="checkbox"
                                                                                            checked={isToggleSwitch}
                                                                                            onChange={(e) => {
                                                                                                //console.log("setIsToggleSwitch:", isToggleSwitch)
                                                                                                setIsToggleSwitch(isToggleSwitch ? false : true)

                                                                                            }}
                                                                                        />
                                                                                        <label htmlFor="switch-2" className="label-toggle flex nice-align-item-center"
                                                                                            style={{
                                                                                                display: "flex",
                                                                                                width: "7rem",
                                                                                                height: "2rem",
                                                                                                backgroundColor: "#C6C6C6"
                                                                                            }}>
                                                                                            <img
                                                                                                style={{
                                                                                                    left: isToggleSwitch ? "-1rem" : "4rem",
                                                                                                    top: "auto",
                                                                                                    width: "3rem",
                                                                                                    height: "3rem",
                                                                                                    backgroundColor: isToggleSwitch ? "#6D6D6D" : "#3bd461"
                                                                                                }}
                                                                                                className="img-responsive"
                                                                                                alt="" />
                                                                                        </label>
                                                                                    </div>
                                                                                    <h4 className="text-20 text-center nice-apply-theme font-family-primary">{trans('info:multiple_degrees')}</h4>
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex flex-row grid-2-cols nice-gap-2rem ">

                                                                                {

                                                                                    (isToggleSwitch) ?


                                                                                        [trans('info:full_car_glass')].map((item, index) => (

                                                                                            <EvaluationType
                                                                                                key={acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index}
                                                                                                uniqueKey={acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index} // Pass it explicitly

                                                                                                title={item}
                                                                                                defultActive={evaluations[acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index]}
                                                                                                mandatory={item?.Mandatory}
                                                                                                error={error[acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index]}
                                                                                                click={(val) => {

                                                                                                    var evalua = { ...evaluations };
                                                                                                    evalua[acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index] = val;
                                                                                                    // avg = avg + val;
                                                                                                    setEvaluations(evalua);

                                                                                                }}
                                                                                            />
                                                                                        ))


                                                                                        :


                                                                                        acticeService ?
                                                                                            evaluationOptions?.map((item, index) => (

                                                                                                <EvaluationType
                                                                                                    key={acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index}
                                                                                                    uniqueKey={acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index} // Pass it explicitly

                                                                                                    title={lang == "ar" ? item.titel : item.titelEn}
                                                                                                    defultActive={evaluations[acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index]}
                                                                                                    mandatory={item.mandatory}
                                                                                                    error={error[acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index]}
                                                                                                    click={(val) => {

                                                                                                        var evalua = { ...evaluations };
                                                                                                        evalua[acticeService?.ServiceID + "_" + isToggleSwitch + "_" + index] = val;
                                                                                                        // avg = avg + val;
                                                                                                        //console.log("evalua", evalua);
                                                                                                        setEvaluations(evalua);

                                                                                                    }}
                                                                                                />
                                                                                            ))
                                                                                            : null

                                                                                }
                                                                            </div>



                                                                            {
                                                                                showTintingAgreements &&
                                                                                <div class="mx-2 mb-5 nice-flex  items-center mt-20">
                                                                                    <img src="/assets/icons/info.svg" class="mx-3 text-inline-block" alt="hassan jameel info " />

                                                                                    <div class="mx-2 mb-5 nice-flex flex flex-col items-center" style={{ whiteSpace: "pre-line" }}>
                                                                                        <p class="text-bold text-18  text-gray text-inline-block">  {showTintingAgreements[lang ?? "ar"]} </p>
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                }


                                                                {
                                                                    !SalesInvoiceTrans.includes(_Srtvice.ServiceID) && (
                                                                        <button
                                                                            onClick={() => {

                                                                                if (!allServiceID.includes(_Srtvice.ServiceID)) {
                                                                                    // Add the service to the lists
                                                                                    setAllSelectServices(prevServices => [...prevServices, _Srtvice]);

                                                                                    setAllServiceID(prevServiceIDs => [...prevServiceIDs, _Srtvice.ServiceID]);
                                                                                } else {
                                                                                    // Remove the service from the lists
                                                                                    setAllSelectServices(prevServices =>
                                                                                        prevServices.filter(service => service !== _Srtvice)
                                                                                    );

                                                                                    setAllServiceID(prevServiceIDs =>
                                                                                        prevServiceIDs.filter(id => !_Srtvice.ServiceID.includes(id))
                                                                                    );
                                                                                }
                                                                            }}
                                                                            className="protection-and-shading-menu-addbtn h-full  flex justify-center items-center">

                                                                            {

                                                                                allServiceID.includes(_Srtvice.ServiceID) ?
                                                                                    <>
                                                                                        <span className='text-white font-bold text-30 mx-5  capitalize'>{" - "}</span>
                                                                                        <span className='text-white font-bold pl-2 text-24 pr-2 capitalize'>{trans('common:cancel')}</span>
                                                                                    </>

                                                                                    :
                                                                                    <>
                                                                                        <span className='text-white font-bold text-30 mx-5  capitalize'>{" + "}</span>
                                                                                        <span className='text-white font-bold pl-2 text-24 pr-2 capitalize'>{trans('common:addition')}</span>
                                                                                    </>



                                                                            }


                                                                        </button>
                                                                    )}


                                                            </div>


                                                        </div>
                                                    </div>
                                                );
                                            })
                                            // < div className="panel-section panel-white bg-theme-up w-100 ">
                                            //     <div
                                            //         className={`panel-content  flex flex-col  nice-shadow-1 border-radius-sm   ${(indexPanel == "2000") ? "show-panel-info" : ""}`}>
                                            //         {

                                            //             <div className='z-whole-pupup-s   py-5 px-10  nice-shadow-0 '>
                                            //                 {

                                            //                     acticeService && acticeService[lang == "ar" ? "ServiceDetails" : "ServiceDetailsEn"] &&
                                            //                     <>

                                            //                         <ul className={'text-30 ' + (indexPanel != "2000" ? " text-line-clamp text-line-clamp-2 " : "")}>

                                            //                             {
                                            //                                 acticeService[lang == "ar" ? "ServiceDetails" : "ServiceDetailsEn"]?.replaceAll("\\n\\n", "\\n")?.split('\n').filter(a => a)?.map((note, index) => {
                                            //                                     return (


                                            //                                         <li key={index} className=' text-25 text-gray'>
                                            //                                             <span style={{ whiteSpace: 'pre-wrap' }} className="text-24 text-gray">{note}</span>
                                            //                                         </li>
                                            //                                     );
                                            //                                 })
                                            //                             }


                                            //                         </ul>
                                            //                         {
                                            //                             indexPanel != "2000" && acticeService[lang == "ar" ? "ServiceDetails" : "ServiceDetailsEn"]?.replaceAll("\\n\\n", "\\n")?.split('\n').filter(a => a)?.length > 2 &&
                                            //                             < span className="mx-10 text-30 text-bold text-primary">
                                            //                                 {"..."}</span>
                                            //                         }



                                            //                     </>

                                            //                 }

                                            //             </div>


                                            //         }



                                            //         <div
                                            //             className='flex flex-row nice-flex-center my-10 w-100'


                                            //             onClick={(e) => setIndexPanel(indexPanel == "2000" ? "000" : "2000")}
                                            //         >

                                            //             <img src="/assets/icons/arrow.svg"
                                            //                 className={"" + (indexPanel == "2000" ? " rotate-180 " : "  ")} />
                                            //         </div>
                                            //     </div>


                                            // </div>
                                        }


                                    </div>
                                </div>
                            </div>
                        }


                        {/* menu tabs */}
                        {
                            allselectServices && allselectServices.length > 0 &&
                            <div className=" more-services bg-secondary-lighter border-radius py-2">

                                <div className=" py-5 flex flex-col ">
                                    <h3 className="text-balck text-bold text-20  text-center ">
                                        {trans("info:الخدمات المضافة ")}</h3>
                                </div>
                                <div className="my-10 nice-apply-theme nice-container nice-relative ">
                                    <Swiper
                                        spaceBetween={3}
                                        slidesPerView={3}
                                        pagination
                                        breakpoints={{
                                            576: {
                                                slidesPerView: 3,
                                            },
                                        }}
                                        className={" my-8  nice-apply-theme"}
                                        resizeObserver={"true"}
                                    >

                                        {allselectServices?.map((_val, _index) => {
                                            return (

                                                <SwiperSlide key={_index} className={""}>
                                                    <div className='flex  nice-relative overflow-hidden'>

                                                        {/* <div className='border-box-periodic-checkInput'> */}
                                                        {/* <CheckInput
                                                                checked={true}
                                                                className="text-primary cursor-pointer"
                                                                oncheng={async (target) => {
                                                                    const isChecked = target.checked;

                                                                    if (isChecked) {
                                                                        // Add the service to the lists
                                                                        setAllSelectServices(prevServices => [...prevServices, _val]);

                                                                        setAllServiceID(prevServiceIDs => [...prevServiceIDs, _val.ServiceID]);
                                                                    } else {
                                                                        // Remove the service from the lists
                                                                        setAllSelectServices(prevServices =>
                                                                            prevServices.filter(service => service !== _val)
                                                                        );

                                                                        setAllServiceID(prevServiceIDs =>
                                                                            prevServiceIDs.filter(id => !_val.ServiceID.includes(id))
                                                                        );
                                                                    }

                                                                }}
                                                                Name={"23-44"}
                                                            >
                                                            </CheckInput> */}
                                                        {/* </div> */}
                                                        <CustomItemServices
                                                            // title={trans("mobileCommon:finance")}
                                                            title={lang == "ar" ? _val.ServiceNameAR : _val.ServiceName}
                                                            borderCSS={"border-primary-box nice-flex-important nice-align-item-center my-5"}

                                                        >
                                                            <div className='border-box-periodic-checkInput'>
                                                                <CheckInput
                                                                    checked={true}
                                                                    className="text-primary cursor-pointer"
                                                                    oncheng={async (target) => {
                                                                        const isChecked = target.checked;

                                                                        if (isChecked) {
                                                                            // Add the service to the lists
                                                                            setAllSelectServices(prevServices => [...prevServices, _val]);

                                                                            setAllServiceID(prevServiceIDs => [...prevServiceIDs, _val.ServiceID]);
                                                                        } else {
                                                                            // Remove the service from the lists
                                                                            setAllSelectServices(prevServices =>
                                                                                prevServices.filter(service => service !== _val)
                                                                            );

                                                                            setAllServiceID(prevServiceIDs =>
                                                                                prevServiceIDs.filter(id => !_val.ServiceID.includes(id))
                                                                            );
                                                                        }

                                                                    }}
                                                                    Name={"23-44"}
                                                                >
                                                                </CheckInput>
                                                            </div>
                                                        </CustomItemServices>
                                                    </div>
                                                </SwiperSlide>

                                            );
                                        })}



                                    </Swiper>
                                </div>
                            </div>
                        }
                        <div className=" nice-container nice-relative">
                            {
                                allselectServices && allselectServices.length > 0 &&
                                <div className="flex flex-col">

                                    {
                                        allselectServices?.map((_val, _index) => {
                                            return (

                                                <div key={_index} className="cart-grid-info-div ">
                                                    <div className={"text-14 text-gray mx-1"}>{lang == "ar" ? _val.ServiceNameAR : _val.ServiceName}&nbsp;</div>
                                                    <div className={"text-14 text-gray mx-1"}> {_val?.PriceExcludeTax ? <Price price={_val?.PriceExcludeTax} className={"white-space-pre"} /> : ""}</div>

                                                </div>

                                            );
                                        })
                                    }
                                </div>
                            }

                            {
                                allselectServices && allselectServices.length > 0 &&
                                <>
                                    <div className="cart-grid-info-div border-tb">
                                        <div className={"text-14  text-black"}>{trans("new:tax_value")}</div>
                                        <div className={"text-14 text-black "}> {allselectServices?.reduce((total, service) => total + service.Price, 0) ? <Price price={allselectServices?.reduce((total, service) => total + (service.Price - service.PriceExcludeTax), 0)} className={"white-space-pre"} /> : ""}</div>
                                    </div>
                                    <div className="cart-grid-info-div border-tb">
                                        <div className={"text-16 font-bold text-black"}>{trans("new:total")}&nbsp;<span className="text-14 text-gray mx-1">{trans("new:total_include_tax")}</span></div>
                                        <div className={"text-16 text-black font-bold"}> {allselectServices?.reduce((total, service) => total + service.Price, 0) ? <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} /> : ""}</div>
                                    </div>
                                </>

                            }

                        </div>


                        <div className=" nice-container nice-relative">
                            <div className=" mt-10 p-4">
                                <TextArea
                                    value={Note}
                                    row={4}
                                    placeholder={trans("info:notes")}
                                    onChangeValue={(data) => {
                                        setNote(data);
                                    }}
                                />
                            </div>
                        </div>

                        <div className="my-20 py-5  bg-gray-lighter ">
                            <div className="flex flex-col nice-gap-2rem nice-container ">
                                <div className="flex flex-row justify-between items-center nice-container">
                                    <h3 className="text-30 font-bold text-black"> {trans("new:pay_method")}</h3>

                                </div>
                                <div className="breakout!! flex flex-col nice-gap-2rem ">


                                    {
                                        platformTypes && platformTypes.includes("payTabs") &&
                                        <div className={"flex flex-col nice-gap-2rem border-radius p-5 " + (paymentType == "payTabs" ? " bg-gray-light " : "")}
                                            onClick={() => {
                                                setPaymentType("payTabs");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "payTabs" ? true : false} name='paymentType'


                                                    onChange={() => {



                                                    }}
                                                    id="primary"
                                                />
                                                {trans("new:online_all")}

                                            </label>
                                            <div className="flex flex-row items-center  mx-10">
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />

                                            </div>

                                        </div>


                                    }

                                    {
                                        platformTypes && platformTypes.includes("myfatoorah") &&
                                        <div className={"flex flex-col nice-gap-2rem border-radius p-5 " + (paymentType == "myfatoorah" ? " bg-gray-light " : "")}
                                            onClick={() => {
                                                setPaymentType("myfatoorah");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "myfatoorah" ? true : false} name='paymentType'


                                                    onChange={() => {



                                                    }}
                                                    id="primary"
                                                />
                                                {trans("new:online_all")}

                                            </label>
                                            <div className="flex flex-row items-center  mx-10">
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/master-card-3.png" alt={"master"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/visa-3.png" alt={"visa"} />
                                                <img className="cart-payment-icon object-contain" src="/assets/icons/companies/mada-3.png" alt={"mada"} />

                                            </div>

                                        </div>


                                    }

                                    {
                                        platformTypes && platformTypes.includes("tamara") &&
                                        <div className={"flex flex-col  border-radius p-5  " + (paymentType == "tamara" ? " bg-gray-light  " : "")}
                                            onClick={() => {

                                                setPaymentType("tamara");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "tamara" ? true : false}
                                                    name='paymentType'

                                                    onChange={() => {
                                                        //console.log("<< PaymentType >>: ", paymentType);
                                                    }}

                                                    id="primary"

                                                />

                                                {trans("new:byTamara")}

                                                <div className="flex flex-row  cart-payment-icon">
                                                    <img className="cart-payment-icon object-contain"
                                                        src={lang == 'ar'
                                                            ? "/assets/icons/AR-tamara.svg"
                                                            : "/assets/icons/En-tamara.svg"}
                                                        alt={""} />
                                                </div>

                                            </label>
                                            <label className={" text-20  flex flex-row  pr-20 pl-20"}>
                                                {trans("new:byTamara3")}
                                            </label>
                                            <label className={" text-20  flex flex-row pr-20 pl-20 "}>
                                                {trans("new:byTamara4")}
                                            </label>
                                        </div>

                                    }

                                    {
                                        platformTypes && platformTypes.includes("tamara") &&
                                        <div
                                            className={"flex flex-col nice-gap-1rem  p-5 " + (paymentType == "tabby" ? "bg-gray-light my-10" : "")}>
                                            <label
                                                className={" text-20 text-bold  flex flex-row nice-gap-1rem  pl-10  items-center"}>
                                                <input type='radio' checked={paymentType == "tabby" ? true : false} name='paymentType'
                                                    onClick={() => {

                                                        setPaymentType("tabby");
                                                    }}
                                                    onChange={() => {

                                                    }}

                                                    id="primary"

                                                // disabled={checkTamarClose === true ? true : false}
                                                />


                                                {lang == "ar" ? "قسّمها على 4 دفعات ,بدون فوائد أو رسوم" : "Pay in 4. No interest, no fees"}

                                                <div className="flex flex-row  ">
                                                    <img className="cart-payment-icon object-contain"
                                                        src={lang == 'ar'
                                                            ? "/assets/icons/tabby.png"
                                                            : "/assets/icons/tabby.png"}
                                                        alt={""}
                                                    // onError={"/assets/icons/companies/tabby.jpeg"}
                                                    />
                                                </div>

                                            </label>
                                            <div id="TabbyPromo"></div>

                                            {
                                                MessageError &&
                                                <div className='language-en  nice-border text-bold flex border-danger flex-col nice-gap-1rem  p-10  my-10 text-danger text-20'
                                                    style={{ backgroundColor: "#ffe6e3" }}
                                                >{MessageError}</div>
                                            }

                                        </div>

                                    }
                                    {
                                        platformTypes && platformTypes.includes("sadad") &&
                                        <div className={"flex flex-col nice-gap-2rem border-radius p-5  " + (paymentType == "sadad" ? " bg-gray-light  " : "")}
                                            onClick={() => {

                                                setPaymentType("sadad");
                                            }}
                                        >
                                            <label className={" text-20 font-bold flex flex-row  items-center nice-gap-1rem "}>
                                                <input type='radio' checked={paymentType == "sadad" ? true : false} name='paymentType'

                                                    onChange={() => {

                                                    }}
                                                    id="primary"
                                                />
                                                <img className=" object-contain"
                                                    src={"/assets/icons/companies/SADAD-Logo.png"} width={"60px"} alt={"SADAD"} />

                                            </label>


                                        </div>

                                    }

                                </div>
                            </div>
                        </div>

                        <ul className="reservation-privacy-link nice-container my-10">
                            {

                                <li className="text-balck text-bold text-24 text-center">
                                    <a className={"text-16 nice-pointer"}
                                        // href="/protectionAndShadingAgreement"
                                        onClick={(e) => {
                                            // e.defaultPrevented();
                                            setshowAgreements(true)
                                        }}
                                    >{trans('offers:terms')}</a>
                                </li>
                            }

                        </ul>

                        <div className="ruler-2 mb-3"></div>
                        {

                            <div className=" nice-container">
                                {

                                    <div className="flex flex-row nice-gap-2rem my-20  ">

                                        {
                                            browser && browser == "Safari" &&
                                                (paymentType == "payTabs" || paymentType == "myfatoorah") ?
                                                <div className=" w-100 mb-5 "
                                                    onClick={() => {

                                                        if (dataFullNum >= 2 && isSendeng == false)
                                                            SendResreve(PVIN, ServiceID, VINDetails[0]?.CustID, infoPrice[0].Price);

                                                    }}

                                                >
                                                    <div title="" className={"nice-style-btn nice-flex-row py-3  text-white text-20 " + (dataFullNum >= 2 ? " bg-black" : " bg-gray ")}
                                                    >
                                                        {
                                                            isSendeng && <span className='mx-2 loading-btn '>
                                                                <img className="object-max-full " src='/assets/icons/loading.svg' width='25' height='25' />
                                                            </span>
                                                        }
                                                        <img className="object-max-full" src="/assets/icons/apple-pay.png" alt="apple-pay" width='70' height='70' />
                                                    </div>
                                                </div>

                                                :


                                                <div className="w-100  mb-5">
                                                    <div className={"nice-bg-btn  text-white text-24 " + (dataFullNum >= 2 ? " bg-primary " : " bg-gray ")}
                                                        onClick={() => {


                                                            if (dataFullNum >= 2 && isSendeng == false)
                                                                SendResreve(PVIN, ServiceID, VINDetails[0]?.CustID, infoPrice[0].Price);

                                                        }}>
                                                        {
                                                            (orderReservation) ?
                                                                trans("info:save_changes")
                                                                :
                                                                trans("cartFile:comlete_buying")

                                                        }

                                                        {
                                                            isSendeng && <span className='mx-2 loading-btn '>
                                                                <img className="object-max-full " src='/assets/icons/loading.svg' width='25' height='25' />
                                                            </span>
                                                        }

                                                    </div>
                                                </div>

                                        }




                                    </div>



                                }

                            </div>
                        }




                        <Popup show={isPopupOpen}>

                            <div className="offer-popup  nice-flex nice-flex-center">
                                <div className="offer-popup-container p-4">
                                    <div className="offer-popup-container-header">
                                        <h1 className="text-balck text-bold text-24 text-center">{trans("new:order_details")}</h1>
                                        <span className='offer-popup-container-header-close text-block text-gray' onClick={() => {
                                            setIsPopupOpen(false)
                                        }}></span>
                                    </div>
                                    <div className="ruler-2 mb-3"></div>
                                    <div className='popup-content'>
                                        <div className="mx-10 my-10">
                                            {
                                                (serviceImportantAdditions && serviceImportantAdditions.ServiceID
                                                    && !allServiceID.includes(serviceImportantAdditions.ServiceID)
                                                    && !SalesInvoiceTrans.includes(serviceImportantAdditions.ServiceID)) &&

                                                <div className=" nice-container nice-relative">


                                                    <div ref={targetRefAdditional} className=" flex nice-flex nice-flex-center">
                                                        <span className="text-balck text-bold text-20 text-center">
                                                            {"  لا تنسى أن تضيف "} </span>

                                                        {

                                                            <button
                                                                onClick={() => {


                                                                    if (!allServiceID.includes(serviceImportantAdditions.ServiceID)) {
                                                                        // Add the service to the lists
                                                                        setAllSelectServices(prevServices => [...prevServices, serviceImportantAdditions]);

                                                                        setAllServiceID(prevServiceIDs => [...prevServiceIDs, serviceImportantAdditions.ServiceID]);
                                                                    } else {
                                                                        // Remove the service from the lists
                                                                        setAllSelectServices(prevServices =>
                                                                            prevServices.filter(service => service !== serviceImportantAdditions)
                                                                        );

                                                                        setAllServiceID(prevServiceIDs =>
                                                                            prevServiceIDs.filter(id => !serviceImportantAdditions.ServiceID.includes(id))
                                                                        );
                                                                    }
                                                                }}
                                                                className="protection-and-shading-menu-addbtn h-full  flex justify-center items-center">

                                                                {

                                                                    allServiceID.includes(serviceImportantAdditions.ServiceID) ?
                                                                        <>
                                                                            <span className='text-white font-bold text-20 mx-5  capitalize'>{" - "}</span>
                                                                            <span className='text-white font-bold pl-2 text-16 pr-2 capitalize'>{trans('common:cancel')}</span>
                                                                        </>

                                                                        :
                                                                        <>
                                                                            <span className='text-white font-bold text-20 mx-5  capitalize'>{" + "}</span>
                                                                            <span className='text-white font-bold pl-2 text-16 pr-2 capitalize'>{trans('common:addition')}</span>
                                                                        </>



                                                                }


                                                            </button>
                                                        }
                                                    </div>

                                                    {
                                                        <div className="protection-and-shading-menu-servie my-5">
                                                            <div className={"text-14 " + (SalesInvoiceTrans.includes(serviceImportantAdditions.ServiceID) ? " text-gray " : " text-super-gray ") + (allServiceID.includes(serviceImportantAdditions.ServiceID) ? " selectd " : "")}>
                                                                {lang == "ar" ? serviceImportantAdditions.ServiceNameAR : serviceImportantAdditions.ServiceName}</div>

                                                            <div className='protection-and-shading-menu-price flex flex-row gap-2 text-bold nice-justifiy-end text-24'>

                                                                {
                                                                    serviceImportantAdditions?.PriceExcludeTax && <Price price={serviceImportantAdditions?.PriceExcludeTax} />
                                                                }
                                                            </div>
                                                        </div>
                                                    }



                                                    <div className="ruler-2 mb-3"></div>
                                                </div>

                                            }
                                            {
                                                <div className=" nice-container nice-relativem my-10">

                                                    {
                                                        allselectServices && allselectServices.length > 0 &&
                                                        <div className="flex flex-col">

                                                            {
                                                                allselectServices?.map((_val, _index) => {
                                                                    return (

                                                                        <div key={_index} className="cart-grid-info-div ">
                                                                            <div className={"text-14 text-gray mx-1"}>{lang == "ar" ? _val.ServiceNameAR : _val.ServiceName}&nbsp;</div>
                                                                            <div className={"text-14 text-gray mx-1"}> {_val?.PriceExcludeTax ? <Price price={_val?.PriceExcludeTax} className={"white-space-pre"} /> : ""}</div>

                                                                        </div>

                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    }

                                                    {
                                                        allselectServices && allselectServices.length > 0 &&
                                                        <>
                                                            <div className="cart-grid-info-div border-tb">
                                                                <div className={"text-14  text-black"}>{trans("new:tax_value")}</div>
                                                                <div className={"text-14 text-black "}> {allselectServices?.reduce((total, service) => total + service.Price, 0) ? <Price price={allselectServices?.reduce((total, service) => total + (service.Price - service.PriceExcludeTax), 0)} className={"white-space-pre"} /> : ""}</div>
                                                            </div>
                                                            <div className="cart-grid-info-div border-tb">
                                                                <div className={"text-16 font-bold text-black"}>{trans("new:total")}&nbsp;<span className="text-14 text-gray mx-1">{trans("new:total_include_tax")}</span></div>
                                                                <div className={"text-16 text-black font-bold"}> {allselectServices?.reduce((total, service) => total + service.Price, 0) ? <Price price={allselectServices?.reduce((total, service) => total + service.Price, 0)} className={"white-space-pre"} /> : ""}</div>
                                                            </div>
                                                        </>
                                                    }

                                                </div>
                                            }

                                        </div>

                                        <div className="ruler-2 mb-3"></div>
                                        {

                                            <div className="flex flex-row nice-gap-2rem my-5  ">
                                                <div className="w-100  mb-5">
                                                    <div className={"nice-bg-btn  text-white text-24 " + (dataFullNum >= 2 ? " bg-primary " : " bg-gray ")}
                                                        onClick={() => popupHandlers.onConfirm(allServiceID)}>
                                                        {trans("new:continuation")}
                                                    </div>
                                                </div>
                                                <div className=" w-100 mb-5 "
                                                    onClick={() => popupHandlers.onCancel(allServiceID)}>
                                                    <div title="" className={"nice-style-btn nice-flex-row py-3  text-white text-20 " + (dataFullNum >= 2 ? " bg-black" : " bg-gray ")}
                                                    >
                                                        {
                                                            isSendeng && <span className='mx-2 loading-btn '>
                                                                <img className="object-max-full " src='/assets/icons/loading.svg' width='25' height='25' />
                                                            </span>
                                                        }
                                                        {trans("info:back")}
                                                    </div>
                                                </div>

                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </Popup>
                    </div >

                    :
                    <>
                        <Skeleton count={1} borderRadius={"2rem"} width={"100%"} height={"20rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />

                        <Skeleton count={3} borderRadius={"2rem"} width={"80%"} height={"5rem"}
                            containerClassName={"flex flex-col"} className={"my-5"}
                            inline={true} />

                        <Skeleton count={3} borderRadius={"2rem"} width={"30%"} height={"10rem"}
                            containerClassName={" flex justify-center items-center"} className={"my-5"}
                            inline={false} />
                        <Skeleton count={4} borderRadius={"2rem"} width={"100%"} height={"5rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />
                        <Skeleton count={2} borderRadius={"2rem"} width={"100%"} height={"40rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />
                        <Skeleton count={1} borderRadius={"2rem"} width={"100%"} height={"10rem"}
                            containerClassName={""} className={"my-5"}
                            inline={true} />

                    </>

            }

            <Popup show={showFinalPopup}>
                <div className="w-full h-full flex flex-column justify-center items-center" >
                    <div className="cart-finalized" >
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" alt="" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {
                                showFinalPopupMessage &&
                                <>
                                    <div className="flex flex-wrap justify-center mx-20">
                                        <span className="text-20 font-bold  mx-2"> {showFinalPopupMessage}</span>
                                    </div>

                                </>

                            }
                            {
                                VINDetails && VINDetails.length > 0 &&
                                <>


                                    {filteredSettings?.groups?.filter(s => s.productGroupID == group).length > 0 &&
                                        <div className="flex flex-row justify-center">
                                            <span className="text-20 font-bold text-primary  mx-2">
                                                {filteredSettings?.groups?.filter(s => s.productGroupID == group)[0]?.description}
                                                {` (${PVIN}) `}</span>
                                        </div>
                                    }

                                    {

                                        resOrderID &&
                                        <div className="flex flex-row justify-center cart-finalized-code"
                                            onClick={() => {

                                                navigator.clipboard.writeText(resOrderID);
                                            }}

                                        >

                                            <span className="text-20 font-bold text-white  mx-2"> {trans("info:order-number") + " :"}</span>
                                            <span className="text-20 font-bold text-white  mx-2">{resOrderID && resOrderID}</span>
                                            <img src="/assets/icons/copy.svg" alt='' />
                                        </div>
                                    }
                                    -
                                </>

                            }
                            <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-16" onClick={() => {

                                        setShowFinalPopup(false);
                                        setResOrderID(null);
                                        if (location.pathname)
                                            history.push("/");

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                    {

                        orderReservation && orderReservation?.OrderStatusID && orderReservation?.OrderStatusID == "Created" &&


                        <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                            <div className=" mb-5 w-100">
                                <div className="nice-sm-btn cart-notification-go  text-white text-16 gap-1" onClick={() => {

                                    var threeDaysFromNow = new Date();
                                    if (orderReservation?.DateIn)
                                        threeDaysFromNow = new Date(orderReservation?.DateIn);
                                    if (orderReservation?.Note)
                                        setNote(orderReservation?.Note);

                                    setRequestForm({
                                        ...requestForm,
                                        date: threeDaysFromNow,
                                        time: orderReservation ? threeDaysFromNow : ""
                                    });

                                    setShowFinalPopup(false);

                                }}>


                                    {/* <img src="/assets/icons/edit.svg" width={20} height={20} alt=""></img> */}
                                    <svg
                                        id="SvgjsSvg1001"
                                        width="15"
                                        height="15"
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        xmlnsSvgjs="http://svgjs.com/svgjs"
                                    >
                                        <defs id="SvgjsDefs1002"></defs>
                                        <g id="SvgjsG1008" transform="matrix(1,0,0,1,0,0)">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="15" height="15">
                                                <path
                                                    d="M18.293 31.707h6.414l24-24-6.414-6.414-24 24v6.414zm27.586-24l-3.586 3.586-3.586-3.586 3.586-3.586 3.586 3.586zM20.293 26.121l17-17 3.586 3.586-17 17h-3.586v-3.586z"
                                                    fill="#ffffff"
                                                    className="color000 svgShape"

                                                ></path>
                                                <path
                                                    d="M45.293 19.707h-2v27h-38v-40h28v-5h-38v50h60z"
                                                    fill="#ffffff"
                                                    className="color000 svgShape"
                                                ></path>
                                            </svg>
                                        </g>
                                    </svg>
                                    {trans("info:edit") + " " + trans("info:the_appointment")}

                                </div>
                            </div>
                        </div>

                    }
                </div>
            </Popup>

            <Popup show={showAgreements}>

                <div className="offer-popup  nice-flex nice-flex-center">
                    <div className="offer-popup-container p-4">
                        <div className="offer-popup-container-header">
                            <h1 className="text-balck text-bold text-24 text-center">{trans("offers:terms")}</h1>
                            <span className='offer-popup-container-header-close text-block text-gray' onClick={() => {
                                setshowAgreements(false)
                            }}></span>
                        </div>
                        <div className="ruler-2 mb-3"></div>
                        <div className='popup-content'>
                            <div className="mx-10 my-10">

                                {
                                    Agreements && Agreements.length > 0 ?
                                        <div className={"new-lines "}>
                                            <ul className={"text-20 my-10 mx-10 leading-relaxed"}>
                                                {
                                                    Agreements[0]?.explaination?.split('\n')?.map((item, index) => {

                                                        return <li className={"text-20 leading-relaxed font-bold"} key={index}>
                                                            {item?.replaceAll("*", " • ")}
                                                        </li>
                                                    })
                                                }
                                            </ul>

                                        </div>
                                        : null
                                }

                            </div>

                            <div className="ruler-2 mb-3"></div>
                        </div>
                    </div>
                </div>
            </Popup>

            {
                isArrowVisible && (
                    <div
                        className="alert-indicator-arrow"
                        style={{
                            top: arrowPosition.top,
                            left: arrowPosition.left,
                            backgroundImage: `url('/assets/alert-indicator-arrow.svg')`, // Set image dynamically
                        }}
                    ></div>
                )
            }
        </>
    );
}